export default "__VITE_ASSET__D7VHWYOv__"